import { Language } from './imageTranslatorTypes.types';

export const SUPPORTED_LANGUAGES: Language[] = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Spanish' },
  { code: 'fr', name: 'French' },
  { code: 'de', name: 'German' },
  { code: 'it', name: 'Italian' },
  { code: 'ja', name: 'Japanese' },
  { code: 'ko', name: 'Korean' },
  { code: 'zh', name: 'Chinese (Simplified)' },
];

export const BOX_SHADOW_PRESETS = [
  { 
    label: 'None',
    value: undefined
  },
  {
    label: 'Subtle',
    value: {
      color: 'rgba(0,0,0,0.2)',
      blur: 4,
      offsetX: 2,
      offsetY: 2,
      opacity: 0.5
    }
  },
  {
    label: 'Medium',
    value: {
      color: 'rgba(0,0,0,0.3)',
      blur: 8,
      offsetX: 4,
      offsetY: 4,
      opacity: 0.7
    }
  },
  {
    label: 'Strong',
    value: {
      color: 'rgba(0,0,0,0.4)',
      blur: 12,
      offsetX: 6,
      offsetY: 6,
      opacity: 0.9
    }
  },
  {
    label: 'Sharp',
    value: {
      color: 'rgba(0,0,0,0.5)',
      blur: 1,
      offsetX: 3,
      offsetY: 3,
      opacity: 1
    }
  },
  {
    label: 'Glow',
    value: {
      color: 'rgba(255,255,255,0.8)',
      blur: 15,
      offsetX: 0,
      offsetY: 0,
      opacity: 1
    }
  }
];
